import './FraudTerms.sass';

import { FC, useCallback, useState } from 'react';

import { Button, Checkbox, List, ListItem, Placeholder, ScrollView } from '$uikit';
import { IcBanOff28, IcInfo28, IcLock28, IcNewTab28 } from '$assets';
import { useDispatch } from 'react-redux';
import { toastActions } from '$store/toast';
import { Api } from '$api';
import { mainActions } from '$store/main';
import { getStorageItem, setStorageItem } from '$utils';
import { useTranslator, useWikiLink } from '$hooks';

export const FraudTerms: FC = () => {
  const dispatch = useDispatch();
  const [step, setStep] = useState(getStorageItem('fraud_terns_seen') === '1' ? 2 : 1);
  const [checked, setChecked] = useState(false);
  const t = useTranslator();

  const link = useWikiLink('/docs-and-terms/safeguarding-against-fraud');

  const handleConfirm = useCallback(() => {
    if (!checked) {
      return dispatch(toastActions.setToastFail(t('third_error_confirm')));
    }

    dispatch(toastActions.setToastLoading());
    Api.post('/profile/fraud_terms/accept')
      .then(() => {
        setStep(3);
        dispatch(toastActions.hideToast());
      })
      .catch((e) => {
        dispatch(toastActions.setToastFail(e.message));
      });
  }, [checked]);

  const handleDone = useCallback(() => {
    dispatch(mainActions.setFraudAccepted(true));
  }, []);

  if (step === 3) {
    return (
      <ScrollView
        className="FraudTerms third_step"
        footer={<Button onClick={handleDone}>{t('third_step_3_button')}</Button>}
      >
        <Placeholder
          centered
          icon={<IcBanOff28 style={{ color: 'var(--tint)', width: 80, height: 80 }} />}
          iconSize={80}
          title={t('third_step_3_title')}
          actions={
            <List>
              <ListItem
                href="https://t.me/tonplacemodels"
                target="_blank"
                chevron
                description={t('third_step_3_link_1_desc')}
              >
                {t('third_step_3_link_1')}
              </ListItem>
              <ListItem
                href="https://t.me/TonPlaceModelsHelpBot"
                target="_blank"
                chevron
                description={t('third_step_3_link_2_desc')}
              >
                {t('third_step_3_link_2')}
              </ListItem>
            </List>
          }
        />
      </ScrollView>
    );
  }

  if (step === 2) {
    return (
      <ScrollView
        className="FraudTerms second_step"
        footer={
          <>
            <div className="FraudTerms__footer__check">
              <Checkbox checked={checked} onClick={() => setChecked(!checked)}>
                {t('third_step_checkbox')}
              </Checkbox>
            </div>
            <Button onClick={handleConfirm}>{t('third_step_2_button')}</Button>
          </>
        }
      >
        <Placeholder
          centered
          icon={<IcInfo28 style={{ color: 'var(--tint)', width: 80, height: 80 }} />}
          iconSize={80}
          title={t('third_step_2_title')}
          actions={
            <List>
              <ListItem
                href={link}
                target="_blank"
                icon={<IcNewTab28 />}
                onClick={() => setStep(2)}
              >
                {t('third_step_2_link')}
              </ListItem>
            </List>
          }
        />
      </ScrollView>
    );
  }

  return (
    <ScrollView
      className="FraudTerms"
      footer={
        <>
          <div className="FraudTerms__footer__check">
            <Checkbox checked={checked} onClick={() => setChecked(!checked)}>
              {t('third_step_checkbox')}
            </Checkbox>
          </div>
          <Button onClick={handleConfirm}>{t('third_step_1_button')}</Button>
        </>
      }
    >
      <Placeholder
        centered
        icon={<IcLock28 style={{ color: 'var(--tint)', width: 80, height: 80 }} />}
        iconSize={80}
        title={t('third_step_1_title')}
        actions={
          <List>
            <ListItem
              href={link}
              target="_blank"
              icon={<IcNewTab28 />}
              onClick={() => {
                setStep(2);
                setStorageItem('fraud_terns_seen', '1');
              }}
            >
              {t('third_step_1_link')}
            </ListItem>
          </List>
        }
      />
    </ScrollView>
  );
};
